import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import EpiContext from '@episerver/spa-core/Spa';
import {connect} from 'react-redux';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';
import {showAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';

const GeneralMessage = ({messageData, buttonClick, secondButtonClick, businessWorkOrderSystem, showAppLoader}) => {
  const {icon, title, secondTitle, subTitle, buttonText, secondButtonText} = messageData;

  const handleSubmit = (buttonAction) => {
    if (buttonAction) {
      buttonAction();
    }
  };

  return (
    <div className='business-work-order-system-general-message-page'>
      <Image src={icon} />
      <p className='l-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, businessWorkOrderSystem, isMobile)}} />
      {secondTitle && (
        <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, businessWorkOrderSystem, isMobile)}} />
      )}
      {subTitle && (
        <p className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(subTitle, businessWorkOrderSystem, isMobile)}} />
      )}
      <div className='continue-button'>
        {buttonText && <BtnSubmit text={buttonText} onclick={() => handleSubmit(buttonClick)} />}
        {secondButtonText && (
          <BtnWhiteBlackBorderBigSize className={`second-button`} text={secondButtonText} onclick={() => handleSubmit(secondButtonClick)} />
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});

const mapDispatchToProps = {showAppLoader};
export default connect(mapStateToProps, mapDispatchToProps)(GeneralMessage);
